import { useEffect, useMemo, useState } from "react";

interface UseImageComponentParams {
  src: string;
  secondSrcImg?: string;
  fallbackSrcs?: string[];
  width?: number | string;
  height?: number | string;
  aspectRatio: number;
}

export const useImageComponent = ({
  src,
  secondSrcImg,
  fallbackSrcs,
  width,
  height,
  aspectRatio,
}: UseImageComponentParams) => {
  const chain = useMemo(() => {
    const merged: string[] = [];
    const push = (url?: string) => {
      if (!url || merged.includes(url)) return;
      merged.push(url);
    };
    push(src);
    push(secondSrcImg);
    fallbackSrcs?.forEach(push);
    return merged;
  }, [src, secondSrcImg, fallbackSrcs]);

  const [activeIndex, setActiveIndex] = useState(0);
  const chainKey = chain.join("|");

  useEffect(() => {
    setActiveIndex(0);
  }, [chainKey]);

  const isFixedSize = typeof width === "number" && typeof height === "number";
  const isFillImage = typeof width !== "number";

  const computedHeight =
    isFixedSize || !width
      ? height
      : typeof width === "number"
        ? width * aspectRatio
        : undefined;

  const handleError = () => {
    setActiveIndex((index) => (index < chain.length - 1 ? index + 1 : index));
  };

  const currentSrc = chain[activeIndex] ?? "";

  return {
    currentSrc,
    computedHeight,
    handleError,
    isFillImage,
  };
};
